export default __webpack_public_path__ + "static/media/K.e40a5194.svg";